<mat-toolbar color="primary" class="title-bar">
  <!-- Left: Logo -->
  <img src="logo.png" alt="App Logo" class="logo">
  &nbsp; braXos Health Monitor

  <!-- Spacer pushes content apart -->
  <span class="spacer"></span>

  <!-- Right: User avatar -->
  <button mat-button class="avatar-btn" [matMenuTriggerFor]="userMenu">
    <ngx-avatars [name]="me?.name" [size]="40"></ngx-avatars>
  </button>

  <mat-menu #userMenu="matMenu">
    <button mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Logout</span>
    </button>
  </mat-menu>

</mat-toolbar>

<mat-sidenav-container class="app-container">
  <mat-sidenav mode="side" opened>
    <mat-nav-list>
      <a mat-list-item [routerLink]="['/dashboard']">
        <mat-icon>dashboard</mat-icon>
        <span class="sidenav-item">Dashboard</span>
      </a>
      <a mat-list-item [routerLink]="['/customer']">
        <mat-icon>groups</mat-icon>
        <span class="sidenav-item">Configure</span>
      </a>
      <a mat-list-item [routerLink]="['/templates']">
         <mat-icon>article</mat-icon>
        <span class="sidenav-item">Templates</span>
      </a>
      <a mat-list-item [href]="downloadsUrl" target="_blank" rel="noopener">
        <mat-icon>open_in_new</mat-icon>
        <span class="sidenav-item">Downloads</span>
      </a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<mat-toolbar class="footer-bar" role="contentinfo">
  <span class="footer-version">{{ version.version }}</span>
</mat-toolbar>

